export default "__VITE_ASSET__ZR3KjMko__"